import { DocumentSingleIcon } from '@grupoboticario/flora-react-icons';
import { checkout } from 'core';
import { PaymentOptions, RadioCard, RadioGroup } from 'ui/components';

const BankSlip = () => {
  const { setBankSlipOption } = checkout.commands.useCheckoutCommand();
  const {
    paymentOption: { paymentCode = '' },
  } = checkout.hooks.useCheckout();

  const {
    data: { bankSlip },
  } = checkout.hooks.usePaymentMethods();

  return (
    <RadioGroup name="payment-type" onChange={setBankSlipOption} value={paymentCode}>
      {bankSlip?.paymentInfo.map((payment) => {
        const { description, name, paymentCode: code } = payment;

        return (
          <RadioCard key={code} value={code}>
            <PaymentOptions description={description} icon={<DocumentSingleIcon />} title={name} />
          </RadioCard>
        );
      })}
    </RadioGroup>
  );
};

export default BankSlip;
